/**
 * @generated SignedSource<<8daa09ed80176142e63de2cca58ed05e>>
 * @relayHash 629a26ef1b288fa22c292d07a19b9ccb
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-finding/362.0.0-2022-04-26T08:27:46.271Z/sendMessageMutation

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ContactDealerInput = {
  buyerId: string;
  displayName?: string | null;
  itemPk?: string | null;
  sellerPk: string;
  messageContent: string;
  isOptIn?: boolean | null;
  action?: string | null;
  pageContext?: string | null;
  currencyConversionRateEventId?: string | null;
  clientMutationId?: string | null;
};
export type sendMessageMutation$variables = {
  input: ContactDealerInput;
};
export type sendMessageMutation$data = {
  readonly contactDealer: {
    readonly conversation: {
      readonly id: string;
    } | null;
  } | null;
};
export type sendMessageMutation = {
  variables: sendMessageMutation$variables;
  response: sendMessageMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ContactDealerPayload",
    "kind": "LinkedField",
    "name": "contactDealer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Conversation",
        "kind": "LinkedField",
        "name": "conversation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "sendMessageMutation",
    "selections": (v1/*: any*/),
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "sendMessageMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "app-buyer-finding/362.0.0-2022-04-26T08:27:46.271Z/sendMessageMutation",
    "metadata": {},
    "name": "sendMessageMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "220832c976b0ad6213d8e667ff2ff6ff";

export default node;
